import * as React from 'react'

import styled from '@emotion/styled'

import { getImageUrl } from '../utils/assets'

const RootContainer = styled.div`
  overflow: hidden;
`

const Background = styled.div`
  background-color: #00d64f;
  position: relative;
  height: 100vh;
  width: 100vw;
  min-height: 720px;
  min-width: 1024px;
`

const TopLeftFlower = styled.img`
  pointer-events: none;
  position: absolute;
  top: 0;
  left: ${props => props.theme.pxToRem(108)};
  height: ${props => props.theme.pxToRem(295)};
  width: ${props => props.theme.pxToRem(423)};
`

const TopRightFlower = styled.img`
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  height: ${props => props.theme.pxToRem(693)};
  width: ${props => props.theme.pxToRem(295)};
`

const BottomLeftFlower = styled.img`
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: ${props => props.theme.pxToRem(58)};
  height: ${props => props.theme.pxToRem(371.5)};
  width: ${props => props.theme.pxToRem(478)};
`

const BottomRightFlower = styled.img`
  pointer-events: none;
  position: absolute;
  bottom: 0;
  right: ${props => props.theme.pxToRem(96)};
  height: ${props => props.theme.pxToRem(212)};
  width: ${props => props.theme.pxToRem(380)};
`

const Flowers: React.FC = () => {
  return (
    <>
      <TopLeftFlower src={getImageUrl('flower_top_left')} alt="" />
      <TopRightFlower src={getImageUrl('flower_top_right')} alt="" />
      <BottomLeftFlower src={getImageUrl('flower_bottom_left')} alt="" />
      <BottomRightFlower src={getImageUrl('flower_bottom_right')} alt="" />
    </>
  )
}

type LoginBackgroundProps = {
  children?: React.ReactNode
}

const LoginBackground: React.FC<LoginBackgroundProps> = ({ children }) => {
  return (
    <RootContainer>
      <Background>
        <Flowers />
        {children}
      </Background>
    </RootContainer>
  )
}

export default LoginBackground
